import { useState, useCallback, useMemo } from 'react';
import { css } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import ModalWithTemplate from 'hb-react/shared/components/DesignSystem/Modal/ModalWithTemplate';
import ThemeProvider from 'hb-react/style/ThemeProvider';

const MoreFiltersModal = ({
  modal,
  onSubmit,
  onCancel,
  hiddenFilters,
  filtersValues,
}) => {
  const { currentUser } = useDefaultAppContexts();

  const [modifiedValues, setModifiedValues] = useState({});

  const handleSubmit = useCallback(() => {
    onSubmit({ ...filtersValues, ...modifiedValues });
  }, [filtersValues, onSubmit, modifiedValues]);

  const modalFiltersValues = useMemo(
    () => ({ ...filtersValues, ...modifiedValues }),
    [filtersValues, modifiedValues],
  );

  return (
    <ThemeProvider theme={currentUser ? 'fo' : 'po'}>
      <ModalWithTemplate
        header={modal?.title || __('Filters')}
        footer={
          <Box>
            <Button
              dataTestId="filters-cancel"
              variant="secondary"
              onClick={onCancel}
            >
              {modal?.cancelButton || __('Cancel')}
            </Button>
            <Box ml={4}>
              <Button dataTestId="filters-ok" onClick={handleSubmit}>
                {modal?.okButton || __('OK')}
              </Button>
            </Box>
          </Box>
        }
        onCloseModal={onCancel}
      >
        <Box
          data-testid="filters-modal"
          as="form"
          mt={-3}
          flex={1}
          flexDirection="column"
          onSubmit={handleSubmit}
        >
          <input
            type="submit"
            // eslint-disable-next-line react/no-unknown-property
            css={css`
              display: none;
            `}
          />

          {hiddenFilters.map(({ id, component: Component }) => (
            <Box
              key={id}
              mt={3}
              data-testid="filters-filter"
              flexDirection="column"
            >
              <Component
                id={id}
                value={modalFiltersValues?.[id]}
                onChange={(value) =>
                  setModifiedValues((prevState) => ({
                    ...prevState,
                    [id]: value,
                  }))
                }
              />
            </Box>
          ))}
        </Box>
      </ModalWithTemplate>
    </ThemeProvider>
  );
};

export default MoreFiltersModal;
